import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewComponent } from './preview/preview.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { QuestionnaireApiService } from 'src/app/services/questionnaire-api.service';
import { ActivatedRoute } from '@angular/router';
import { MiniHeaderComponent } from 'src/app/main-layout/mini-header/mini-header.component';
import { Questionnaire } from 'src/app/models/questionnaire.model';
import { DragStore } from 'src/app/store/drag-store';
import { AnswersStore } from 'src/app/store/answers-store';
import { filter, map } from 'rxjs';
import { QuestionnaireRow } from 'src/app/models/questionnaireGrid.model';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'que-warp-preview',
    imports: [CommonModule, PreviewComponent, MiniHeaderComponent],
    providers: [QuestionnaireStore, DragStore, AnswersStore],
    templateUrl: './warp-preview.component.html',
    styleUrls: ['./warp-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarpPreviewComponent {
  // @Input()
  // template?: QuestionnaireRow;
  #questionnaireStore = inject(QuestionnaireStore);
  #answersStore = inject(AnswersStore);
  #questionnaireApiService = inject(QuestionnaireApiService);
  #activeRoutes = inject(ActivatedRoute);


  questionnaireName = this.#questionnaireStore.name$;
  ngOnInit(): void {
    // if (this.template) {
    //   const q = { id: this.template.id, steps: [this.template.firstStep], definitions: { ...this.template.definitions, mainColor: this.template.definitions.mainColor??"#02A4EF", secondaryColor: this.template.definitions.secondaryColor??"#D1EFFF", backColor: this.template.definitions.backColor??"#F0F3FA" } } as Questionnaire;
    //   this.#questionnaireStore.updateQuestionnaire(q)
    //   this.#questionnaireStore.updateCurrentStepIndex(0);
    // } else {
    this.#questionnaireStore.updateIsInFillQuestionnaire(true);
    const guid$ = this.#activeRoutes.params.pipe(
      map(p => p['guid']), filter(x => x != 0))
    // const selectedId$ = this.#activeRoutes.params.pipe(
    // filter(p => !isNaN(p['id'] as number)), map(p => p['id'] as number),filter(x=>x!=0))
    // this.#questionnaireStore.fetchQuestionnaireById(selectedId$)
    // this.#answersStore.updateQuestionnaireId(selectedId$)
    this.#questionnaireStore.fetchQuestionnaireByGuid(guid$)
    this.#answersStore.updateQuestionnaireGuid(guid$)
    // }
  }


}
